/* AuditFeed — append-only audit visibility. RLS-governed: admins
 * see all account events; reviewers see only V.I rows.
 */
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

const ACTION_LABEL = {
  'account.created':            'Account created',
  'member.invited':             'Member invited',
  'member.invitation_accepted': 'Invitation accepted',
  'member.invitation_revoked':  'Invitation revoked',
  'member.invitation_expired':  'Invitation expired',
  'member.revoked':             'Member revoked',
  'member.role_modified':       'Role modified',
  'member.suspended':           'Member suspended',
  'member.suspended_emergency': 'Emergency suspension',
  'member.unsuspended':         'Suspension lifted',
  'member.suspension_expired':  'Suspension expired',
  'member.bulk_revoked':        'Bulk member revoke',
  'member.bulk_role_modified':  'Bulk role modify',
  'member.bulk_invited':        'Bulk invitation',
};

export function AuditFeed({ audit }) {
  if (!audit.length) {
    return (
      <Card className="p-8 text-center text-sm text-slate-300" data-testid="emp-audit-empty">
        No audit events visible to you for this account.
      </Card>
    );
  }
  return (
    <div className="space-y-2" data-testid="emp-audit-feed">
      {audit.map((row) => (
        <Card key={row.id} className="flex flex-col gap-1 p-3 sm:flex-row sm:items-center"
          data-testid={`emp-audit-row-${row.id}`}>
          <div className="flex flex-1 items-center gap-3">
            <Badge variant="outline" data-testid={`emp-audit-class-${row.id}`}>
              {row.actor_authority_class || '—'}
            </Badge>
            <div>
              <p className="text-sm font-medium">
                {ACTION_LABEL[row.action_class] || row.action_class}
              </p>
              <p className="font-mono text-xs text-slate-300">
                actor {row.actor_identity?.slice(0, 8)}…
              </p>
            </div>
          </div>
          <div className="text-xs text-slate-300 sm:text-right">
            {row.timestamp_utc ? new Date(row.timestamp_utc).toLocaleString() : ''}
          </div>
        </Card>
      ))}
    </div>
  );
}
